// extracted by mini-css-extract-plugin
export var dividerContainer = "_99-0";
export var line = "_99-1";